import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/cn";
import { LOGO_MARK, LOGO_WORDMARK, LOGO_FULL } from "../../assets/logo";

const SOURCES = {
  mark: LOGO_MARK,
  wordmark: LOGO_WORDMARK,
  full: LOGO_FULL,
} as const;

export type LogoVariant = keyof typeof SOURCES;

const logo = cva("w-auto object-contain", {
  variants: {
    size: {
      sm: "h-6",
      base: "h-8",
      lg: "h-10",
    },
  },
  defaultVariants: { size: "base" },
});

type LogoProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> &
  VariantProps<typeof logo> & {
    // "mark" — icon only. "wordmark" — icon + "LendCord" text, for nav/header
    // contexts. "full" — icon + wordmark + legal entity name, for footer/legal
    // contexts where the full registered name matters.
    variant?: LogoVariant;
  };

export function Logo({ variant = "wordmark", size, className = "", alt = "Lendcord", ...props }: LogoProps) {
  return <img src={SOURCES[variant]} alt={alt} className={cn(logo({ size }), className)} {...props} />;
}
